import { HttpErrorResponse } from "@angular/common/http";
import { ImportMode, ImportOption } from "src/app/_models/Import/ImportModel";

export interface ImportState {
  uploadLoader: boolean;
  uploadResult: boolean;
  uploadError: HttpErrorResponse;
  statusLoader: boolean;
  statusResult: ImportStatus; 
  statusError: HttpErrorResponse;
  authSSELoader: boolean;
  authSSEResult: boolean;
  authSSEError: HttpErrorResponse;
  errorListLoader: boolean;
  errorListFile: string[];
  errorListError: HttpErrorResponse;
  hasImportLoader: boolean;
  hasImportError: HttpErrorResponse;
  hasImportResult: number;
  clearSessionLoader: boolean;

  cancelImportLoader: boolean;
  cancelImportResult: boolean | null;
}

export interface ImportStatus {
  Mode: ImportMode,
  Option: ImportOption[],
  Completed: number,
  Failed: number,
  Total: number,
  LineError: LineError[],
  Errors: [],
  Cancelled: boolean,
  NoAction: number
}

export interface LineError {
  line: number;
  message: string;
}

export const initialImportState: ImportState = {
  uploadLoader: false,
  uploadResult: null,
  uploadError: null,
  statusLoader: false,
  statusResult: null,
  statusError: null,
  authSSELoader: false,
  authSSEResult: false,
  authSSEError: null,
  errorListLoader: false,
  errorListFile: [],
  errorListError: null,
  hasImportLoader: false,
  hasImportError: null,
  hasImportResult: 0,
  clearSessionLoader: false,
  cancelImportLoader: false,
  cancelImportResult: null
}